import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { Observable } from 'rxjs';
import { DataListModel } from '../../models/data-list-model';
import { HttpParams } from '@angular/common/http';
import { Upload } from '../../dto/upload';
import { Company } from '../../dto/company';
import { CrudService } from '../../services';
import {PartnerApiKey, PartnerApiKeyAddModel, PartnerApiKeyType, PartnerCounter} from "../../dto/partner-api-key";

@Injectable({
  providedIn: 'root'
})
export class CompanyService implements CrudService<Company> {
    readonly apiPath = 'companies/';
    private readonly jsonHeader = new HttpHeaders({ 'Content-Type': 'application/json' });
    constructor(
      private http: HttpClient,
    ) { }

    getMany(
      pageIndex: number,
      pageSize: number,
      sortField: string,
      sortDirection: string,
      filterString: string,
    ): Observable<DataListModel<Company>> {
      const params = new HttpParams()
      .set('page',            pageIndex.toString())
      .set('pageSize',        pageSize.toString())
      .set('filterString',    filterString)
      .set('sortField',       sortField)
      .set('sortDirection',   sortDirection);
        return this.http.get(this.apiPath, { params }) as Observable<DataListModel<Company>>;
    }

    getAll(): Observable<DataListModel<Company>> {
      return this.http.get(this.apiPath) as Observable<DataListModel<Company>>;
    }

    get(id: number): Observable<Company> {
      return this.http.get(this.apiPath + id) as Observable<Company>;
    }

  getApiKeys(companyId: number): Observable<PartnerApiKey[]> {
    return this.http.get(this.apiPath + companyId + '/api-keys') as Observable<PartnerApiKey[]>;
  }

  getPartnerCounters(id: number, year: number, month: number): Observable<PartnerCounter[]> {
    return this.http.get(this.apiPath + id + '/api-keys') as Observable<PartnerCounter[]>;
  }

  getCardProcessorEnquiryEnabledForLoggedInPartner(): Observable<boolean> {
    return this.http.get(this.apiPath + 'getCardProcessorEnquiryEnabledForLoggedInPartner') as Observable<boolean>;
  }

    add(item: Company): Observable<Company> {
      return this.http.post(this.apiPath, item) as Observable<Company>;
    }

    addImage(item: File): Observable<Upload> {
      const data = new FormData();
      data.append('image', item, item.name);
      return this.http.post(this.apiPath + 'image', data) as Observable<Upload>;
    }

    update(id: number, item: Company): Observable<Object> {
      return this.http.put(this.apiPath + id, item);
    }

    delete(id: any) {
      return this.deleteMany([id]);
    }
    restore(id: any) {
      return this.restoreMany([id]);
    }

    deleteMany(idList: any[]): Observable<Object> {
      let httpParams = new HttpParams();

      idList.forEach(id => {
        httpParams = httpParams.append('list', id.toString());
      });

      return this.http.delete(this.apiPath, { params: httpParams });
    }
    restoreMany(idList: any[]): Observable<Object> {
      let httpParams = new HttpParams();
      idList.forEach(id => {
        httpParams = httpParams.append('list', id.toString());
      });
      return this.http.patch(this.apiPath, null, { params: httpParams });
    }

  deleteApiKey(apiKeyId: string): Observable<string> {
    return this.http.delete(this.apiPath + 'api-key/' + apiKeyId, ) as Observable<string>;
  }

  disableApiKey(apiKeyId: string): Observable<string> {
    return this.http.post(this.apiPath + 'api-key/disable', JSON.stringify(apiKeyId), { headers: this.jsonHeader }) as Observable<string>;
  }

  enableApiKey(apiKeyId: string): Observable<string> {
    return this.http.post(this.apiPath + 'api-key/enable', JSON.stringify(apiKeyId), { headers: this.jsonHeader }) as Observable<string>;
  }

  createApiKey(apiKey: PartnerApiKeyAddModel): Observable<string> {
    return this.http.post(this.apiPath + 'api-key', apiKey) as Observable<string>;
  }

  updatePartnerApiKey(apiKeyId: string, newPermissions: string, newComment: string, newApiKeyType: PartnerApiKeyType): Observable<string> {
    return this.http.put(this.apiPath + 'api-key/update/' + apiKeyId, JSON.stringify({permissions: newPermissions, comment: newComment, apiKeyType: newApiKeyType}), { headers: this.jsonHeader }) as Observable<string>;
  }

  getApiKey(companyId: number, apiKeyId: string): Observable<PartnerApiKey> {
    return this.http.get(this.apiPath + companyId + '/api-key/get/' + apiKeyId) as Observable<PartnerApiKey>;
  }
}
